export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-50">
      {/* World map decoration */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04]">
          <div className="w-full h-full" style={{
            backgroundImage: "radial-gradient(circle at 30% 50%, white 1px, transparent 1px), radial-gradient(circle at 70% 20%, white 1px, transparent 1px), radial-gradient(circle at 50% 70%, white 1px, transparent 1px), radial-gradient(circle at 20% 80%, white 1px, transparent 1px), radial-gradient(circle at 80% 60%, white 1px, transparent 1px)",
            backgroundSize: "80px 80px, 100px 100px, 60px 60px, 90px 90px, 70px 70px",
          }}></div>
        </div>

        <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
            {/* Left */}
            <div>
              <a href="/" className="font-heading text-2xl font-semibold text-background-50 whitespace-nowrap">
                kakobuyfinds<span className="text-accent-400">.forum</span>
              </a>

              <div className="mt-8 flex items-center gap-3 max-w-sm">
                <input
                  type="email"
                  placeholder="Twój adres e-mail"
                  className="flex-1 px-4 py-3 bg-background-50/10 border border-background-50/20 rounded-xl text-background-50 placeholder:text-background-50/40 text-sm outline-none focus:border-accent-400 transition-colors"
                />
                <button className="w-11 h-11 bg-accent-500 rounded-xl flex items-center justify-center hover:bg-accent-600 transition-colors cursor-pointer flex-shrink-0">
                  <i className="ri-notification-3-line text-background-50 w-5 h-5 flex items-center justify-center"></i>
                </button>
              </div>

              <p className="mt-4 font-heading text-background-50/60 text-lg leading-relaxed">
                Nigdy nie przegap
                <br />
                najlepszych znalezisk
              </p>
            </div>

            {/* Right – Link Columns */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-4">Kategorie</h4>
                <ul className="space-y-2.5">
                  <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">Buty</a></li>
                  <li><a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">Bluzy / Swetry</a></li>
                  <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">T-Shirty</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-4">Poradniki</h4>
                <ul className="space-y-2.5">
                  <li><a href="/blog/kakobuy-spreadsheet-2026-guide" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">Kakobuy Guide</a></li>
                  <li><a href="/blog/jak-dziala-kakobuy-spreadsheet" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">Jak działa?</a></li>
                  <li><a href="/blog/kakobuy-finds-guide" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">Kakobuy Finds</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-4">Agent Zakupowy</h4>
                <ul className="space-y-2.5">
                  <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">kakobuy sheet</a></li>
                  <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">buy it now</a></li>
                  <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">Kaspreadsheet</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-4">Pomoc</h4>
                <ul className="space-y-2.5">
                  <li><a href="/blog/kakobuy-spreadsheet-2026-guide" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">FAQ</a></li>
                  <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">Kontakt</a></li>
                  <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-accent-400 transition-colors whitespace-nowrap">Strona Główna</a></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-14 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">&copy; 2025 KakobuyFinds.forum</p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 border border-background-50/15 rounded-lg flex items-center justify-center hover:border-accent-400 hover:text-accent-400 transition-all cursor-pointer">
                <i className="ri-instagram-line w-4 h-4 flex items-center justify-center text-background-50/60"></i>
              </a>
              <a href="#" className="w-9 h-9 border border-background-50/15 rounded-lg flex items-center justify-center hover:border-accent-400 hover:text-accent-400 transition-all cursor-pointer">
                <i className="ri-twitter-x-line w-4 h-4 flex items-center justify-center text-background-50/60"></i>
              </a>
              <a href="#" className="w-9 h-9 border border-background-50/15 rounded-lg flex items-center justify-center hover:border-accent-400 hover:text-accent-400 transition-all cursor-pointer">
                <i className="ri-discord-line w-4 h-4 flex items-center justify-center text-background-50/60"></i>
              </a>
              <a href="#" className="w-9 h-9 border border-background-50/15 rounded-lg flex items-center justify-center hover:border-accent-400 hover:text-accent-400 transition-all cursor-pointer">
                <i className="ri-telegram-line w-4 h-4 flex items-center justify-center text-background-50/60"></i>
              </a>
            </div>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap">
              Polityka prywatności
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}